let numericFormatter = new Intl.NumberFormat('en-UK', {
    style: 'decimal',
    minimumFractionDigits: 0,
});

export const numberWithCommas = (x) => {
    return numericFormatter.format(x);
};

export const handleSmallImages = (smallImage) => {
    if (!smallImage || typeof smallImage !== 'string') return smallImage;

    // Preserve query/hash if present
    const hashIndex = smallImage.indexOf('#');
    const queryIndex = smallImage.indexOf('?');
    const cutIndex = (() => {
        if (hashIndex !== -1 && queryIndex !== -1) return Math.min(hashIndex, queryIndex);
        if (hashIndex !== -1) return hashIndex;
        if (queryIndex !== -1) return queryIndex;
        return -1;
    })();

    const base = cutIndex === -1 ? smallImage : smallImage.substring(0, cutIndex);
    const suffix = cutIndex === -1 ? '' : smallImage.substring(cutIndex);

    // Normalize backslashes to forward slashes for URLs
    const normalized = base.replace(/\\/g, '/');

    // Find the last dot after the last slash
    const lastSlash = normalized.lastIndexOf('/');
    const lastDot = normalized.lastIndexOf('.');

    // If there's an extension (dot after last slash), insert _small before it
    if (lastDot > lastSlash) {
        const beforeExt = normalized.substring(0, lastDot);
        // Avoid duplicating the tag if already present
        if (beforeExt.endsWith('_small')) {
            return `${normalized}${suffix}`;
        }
        return `${beforeExt}_small${normalized.substring(lastDot)}${suffix}`;
    }

    // No extension found; just append _small before any query/hash
    return `${normalized}_small${suffix}`;
};

export const getAddressFullName = (address) => {
    let fullName = '';

    if (address === null){
        return '';
    }

    if (address.addressIndividual === true) {
        if (address.addressIndividualTitle !== null && address.addressIndividualTitle !== '') {
            fullName = address.addressIndividualTitle + ' ';
        }
        if (address.addressIndividualFirstName !== null && address.addressIndividualFirstName !== '') {
            fullName += address.addressIndividualFirstName + ' ';
        }
        if (address.addressIndividualSurname !== null && address.addressIndividualSurname !== '') {
            fullName += address.addressIndividualSurname + ' ';
        }
        if (address.addressIndividualSuffix !== null && address.addressIndividualSuffix !== '') {
            fullName += address.addressIndividualSuffix;
        }
    } else {
        fullName = address.addressOrganisationName;
    }
    
    return fullName;
};

export const getSysSetting = (id) => {
    let settings = JSON.parse(localStorage.getItem('sys_settings'));
    
    return settings.filter(function(item) { return item.id === id; })[0];
};
